import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as Options from '../../select-options';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {MatSelectModule} from '@angular/material/select';

@Component({
  selector: 'app-financial-modal',
  templateUrl: './financial-modal.component.html',
  styleUrls: ['./financial-modal.component.scss'],
})
export class FinancialModalComponent {

  modalTitle: string;
  serviceForm!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<FinancialModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    this.modalTitle = data.modalTitle;
    this.serviceForm = this.fb.group({
      selectedService: ['', Validators.required],
      selectedServiceType: ['', Validators.required],
      rated_cost: [''],
      actual_cost: [''],
      billable: [''],
    });
  }

  getServices(): string[] {
    return Options.SERVICES;
  }

  getServiceType(service: string): string[] {
    let serviceTypes = [''];

    if (service === 'Service Program') {
      serviceTypes = Options.SERVICE_PROGRAM;
    }
    else if (service === 'Accessorial Service') {
      serviceTypes = Options.ACCESSORIAL_TYPE;
    }
    else if (service === 'Surcharge Service') {
      serviceTypes = Options.SURCHARGE_TYPE;
    }
    else if (service === 'Tradeshow Service') {
      serviceTypes = Options.TRADESHOW_TYPE;
    }
    else if (service === 'Trailer Build Service') {
      serviceTypes = Options.TRAILER_BUILD_TYPE;
    }
    else if (service === 'Suncor Service') {
      serviceTypes = Options.SUNCOR_TYPE;
    }
    else if (service === 'Customs Service') {
      serviceTypes = Options.CUSTOMS_TYPE;
    }
    else if (service === 'Delivery Service') {
      serviceTypes = Options.DELIVERY_TYPE;
    }
    else if (service === 'Pickup Service') {
      serviceTypes = Options.PICKUP_TYPE;
    }
    else {
      serviceTypes = Options.LABOURER_TYPE;
    }

    return serviceTypes;
  }

  closeModal() {
    this.dialogRef.close();
  }

  submitForm() {
    // Handle form submission here
    if (this.serviceForm.valid) {
      console.log(this.serviceForm.value);
      this.dialogRef.close(this.serviceForm)
    }
  }

}
